import {
  RESET,
  SET_ACTIVE_ORDER,
  SET_ACTIVE_VIEW,
  SET_CARDS,
  SET_CARDS_IN_COLUMN,
  SET_COLUMNS,
  SET_IS_DELETE_STATUS_COLUMN_MODAL_OPEN,
  SET_IS_FETCHING_CARDS,
  SET_IS_FETCHING_COLUMNS,
  SET_IS_FETCHING_SETTINGS,
  SET_IS_ORDER_MODAL_OPEN,
  SET_SELECTED_COLUMNS,
  SET_SELECTED_STATUS_COLUMN,
  SET_SETTINGS,
} from "./workflow.actionTypes";

const initialState = {
  isFetchingSettings: false,
  isFetchingColumns: false,
  isFetchingCards: false,
  isOrderModalOpen: false,
  isDeleteStatusColumnModalOpen: false,
  settings: {
    enableEmailNotifications: false,
    enableSmsNotifications: false,
    notifyWhenDelivered: false,
    replyTo: null,
    deliveryColor: "#20b2aa",
    pickupColor: "#6a5acd",
    installColor: "#4169e1",
    reservedNames: [],
  },
  columns: [],
  selectedColumns: [],
  selectedStatusColumn: null,
  cards: {},
  activeView: "status",
  activeOrder: null,
  currentFilter: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SETTINGS: {
      return { ...state, settings: { ...state.settings, ...action.payload } };
    }

    case SET_IS_FETCHING_SETTINGS: {
      return { ...state, isFetchingSettings: action.payload };
    }

    case SET_COLUMNS: {
      return { ...state, columns: action.payload };
    }

    case SET_SELECTED_COLUMNS: {
      return { ...state, selectedColumns: action.payload };
    }

    case SET_IS_FETCHING_COLUMNS: {
      return { ...state, isFetchingColumns: action.payload };
    }

    case SET_CARDS: {
      return { ...state, cards: action.payload };
    }

    case SET_IS_FETCHING_CARDS: {
      return { ...state, isFetchingCards: action.payload };
    }

    case SET_CARDS_IN_COLUMN: {
      const { data, columnId } = action.payload;
      return {
        ...state,
        cards: {
          ...state.cards,
          [columnId]: data,
        },
      };
    }

    case SET_ACTIVE_VIEW: {
      return {
        ...state,
        activeView: action.payload,
      };
    }

    case SET_ACTIVE_ORDER: {
      return {
        ...state,
        activeOrder: action.payload,
      };
    }

    case SET_IS_ORDER_MODAL_OPEN: {
      return {
        ...state,
        isOrderModalOpen: action.payload,
      };
    }

    case SET_IS_DELETE_STATUS_COLUMN_MODAL_OPEN: {
      return {
        ...state,
        isDeleteStatusColumnModalOpen: action.payload,
      };
    }

    case SET_SELECTED_STATUS_COLUMN: {
      return {
        ...state,
        selectedStatusColumn: action.payload,
      };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
